import { render, staticRenderFns } from "./ProductMenuSettingContent.vue?vue&type=template&id=5226b13e&"
import script from "./ProductMenuSettingContent.vue?vue&type=script&lang=ts&"
export * from "./ProductMenuSettingContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMenuSettingContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports